import { Skeleton } from "@/components/ui/skeleton"
import { Card, CardHeader } from "@/components/ui/card"

/** Matches the 4-card stats grid on DashboardPage (Total Yield, Annual Income, etc.) */
export function StatsCardSkeleton() {
	return (
		<Card className="bg-white/60 dark:bg-black/20 backdrop-blur-md border-sky-900/10 dark:border-sky-100/10">
			<CardHeader className="pb-2">
				<Skeleton className="h-4 w-28 mb-2" />
				<Skeleton className="h-8 w-36" />
			</CardHeader>
		</Card>
	)
}

/** Matches the This Month / YTD / Last Year / YoY Growth income summary cards */
export function IncomeSummaryCardSkeleton() {
	return (
		<div className="p-3 bg-white/60 dark:bg-black/20 backdrop-blur-md rounded-xl border border-sky-900/10 dark:border-sky-100/10">
			<Skeleton className="h-3 w-20" />
			<Skeleton className="h-6 w-24 mt-2" />
		</div>
	)
}

/** Matches dividend income history rows in StockDetailSheet */
export function DividendHistoryRowSkeleton() {
	return (
		<div className="p-2 rounded-lg border border-sky-100 dark:border-sky-900/30">
			<div className="flex justify-between items-center">
				<div className="flex gap-2 items-center">
					<Skeleton className="h-4 w-24" />
					<Skeleton className="h-3 w-28" />
				</div>
				<div className="flex items-center gap-2">
					<Skeleton className="h-4 w-16" />
					<Skeleton className="h-5 w-10 rounded-full" />
				</div>
			</div>
		</div>
	)
}

/** Matches the DividendBarChart loading state — 12 bars of varying heights */
export function BarChartSkeleton() {
	const heights = [60, 80, 45, 90, 70, 55, 85, 65, 75, 50, 80, 70]
	return (
		<div className="h-[280px] flex items-end gap-2 px-2 pt-4">
			{heights.map((h, i) => (
				<Skeleton key={i} className="flex-1 rounded-sm" style={{ height: `${h}%` }} />
			))}
		</div>
	)
}

/** Matches the PerformanceSection loading state — chart area + 3 insight cards */
export function PerformanceChartSkeleton() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<div className="space-y-1">
					<Skeleton className="h-5 w-48" />
					<Skeleton className="h-4 w-36" />
				</div>
				<Skeleton className="h-7 w-48 rounded-full" />
			</div>
			<Skeleton className="h-64 w-full rounded-lg" />
			<div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
				<div className="p-3 rounded-xl border border-sky-900/10 dark:border-sky-100/10 space-y-2">
					<Skeleton className="h-3 w-20" />
					<Skeleton className="h-6 w-24" />
					<Skeleton className="h-3 w-16" />
				</div>
				<div className="p-3 rounded-xl border border-sky-900/10 dark:border-sky-100/10 space-y-2">
					<Skeleton className="h-3 w-20" />
					<Skeleton className="h-6 w-24" />
					<Skeleton className="h-3 w-16" />
				</div>
				<div className="p-3 rounded-xl border border-sky-900/10 dark:border-sky-100/10 space-y-2">
					<Skeleton className="h-3 w-20" />
					<Skeleton className="h-6 w-24" />
					<Skeleton className="h-3 w-16" />
				</div>
			</div>
		</div>
	)
}

/** Matches the FIRE progress area in FireSummaryWidget */
export function FireWidgetSkeleton() {
	return (
		<div className="mt-3 flex items-end gap-4">
			<div>
				<Skeleton className="h-8 w-16" />
				<Skeleton className="h-3 w-20 mt-1" />
			</div>
			<div className="flex-1 space-y-1.5">
				<Skeleton className="h-3 w-full rounded-full" />
				<Skeleton className="h-3 w-40" />
			</div>
		</div>
	)
}
